import React from 'react';
import { DeliveryAdvice, FreeText, IdentityFields, MultiChoice, Note, SingleChoice } from './qualityAlertBlocks';

const NclFeedbackAlertForm = ({ template, fields, context, advice, onField, onContext, readOnly }) => (
  <div className="qa-form">
    <h3>{template.displayName}</h3>
    <Note text={template.intro} warning />
    <IdentityFields fields={template.identityFields} context={context} readOnly={readOnly} onContext={onContext} />
    <SingleChoice
      label="1) Provider (select one)"
      groups={template.providers}
      other
      value={fields.provider}
      readOnly={readOnly}
      onChange={(value) => onField('provider', value)}
    />
    <FreeText label="2) Specialty / service" value={fields.specialty} readOnly={readOnly} onChange={(value) => onField('specialty', value)} />
    <FreeText label="Specialty / service email (optional)" value={fields.specialtyEmail} readOnly={readOnly} onChange={(value) => onField('specialtyEmail', value)} />
    <FreeText label="Consultant / lead clinician name (optional)" value={fields.consultantName} readOnly={readOnly} onChange={(value) => onField('consultantName', value)} />
    <MultiChoice
      label="3) Nature of concern (select all that apply)"
      groups={template.concerns}
      other
      value={fields.concerns}
      readOnly={readOnly}
      onChange={(value) => onField('concerns', value)}
    />
    <FreeText label="4) Details of concern" multiline value={fields.details} readOnly={readOnly} onChange={(value) => onField('details', value)} />
    <SingleChoice
      label="5) Actions required of the specialty / service (select one)"
      options={template.actions}
      value={fields.action}
      readOnly={readOnly}
      onChange={(value) => onField('action', value)}
    />
    <SingleChoice
      label="6) How to submit concern(s) (select one)"
      options={template.submissions}
      value={fields.submission}
      readOnly={readOnly}
      onChange={(value) => onField('submission', value)}
    />
    <DeliveryAdvice advice={advice} attachmentNote={template.attachmentNote} />
  </div>
);

export default NclFeedbackAlertForm;
